<!-- Navigation -->
<nav
  class="navbar d-block text-center top-bar"
  [class.text-white]="appContext.siteName == 'DemoPortal'"
  *ngIf="displaySetting?.header?.topBarText"
>
  {{ displaySetting?.header?.topBarText }}
</nav>
<nav
  [ngClass]="
    appContext.siteName === 'Joy'
      ? 'navbar navbar-expand-lg navbar-light'
      : appContext.siteName === 'DemoPortal'
      ? 'navbar navbar-expand-lg navbar-light'
      : appContext.siteName === 'Gocaribbea'
      ? 'navbar navbar-expand-lg navbar-light bmc-shadow'
      : 'navbar navbar-expand-lg navbar-light shadow'
  "
  [class.alldotgay-navbar]="appContext.siteName === 'alldotgay'"
>
  <div
    class="container-fluid checkout-container container"
    [ngClass]="{ wrapper: !mobileView }"
  >
    <div *ngIf="mobileView && appContext.siteName == 'ShamalGroup'">
      <ul class="navbar-nav">
        <li class="authList">
          <ng-container
            *ngIf="
              (userDetails != null &&
                displaySetting.pageTitlePrefix !== 'ShamalGroup-B2B') ||
                (auth.isLoggedIn &&
                  appContext?.siteName !== 'Gocaribbea' &&
                  appContext?.siteName !== 'Hotelusso' &&
                  appContext?.siteName !== 'SecretEscapades' &&
                  displaySetting.pageTitlePrefix !== 'ShamalGroup') ||
                (auth.isLoggedIn &&
                  this.appContext.siteName !== 'ShamalGroup' &&
                  appContext?.siteName !== 'Gocaribbea' &&
                  appContext?.siteName !== 'Hotelusso' &&
                  appContext?.siteName !== 'SecretEscapades');
              else guestView
            "
          >
            <a
              class="user-name-view"
              cdkOverlayOrigin
              #usermenu="cdkOverlayOrigin"
              (click)="isUserMenuOpen = !isUserMenuOpen"
            >
              <i class="fa fa-user-circle user-icon" aria-hidden="true"></i>
            </a>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayBackdropClass]="'cdk-overlay-custom-backdrop'"
              [cdkConnectedOverlayOrigin]="usermenu"
              [cdkConnectedOverlayOpen]="isUserMenuOpen"
              (backdropClick)="isUserMenuOpen = false"
            >
              <div class="user-menu">
                <span class="sg-user-name">{{ userDetails.email }}</span>
                <br />
                <a class="sg-logout" (click)="logout()">
                  <i class="fa fa-sign-out" aria-hidden="true"></i> Logout
                </a>
              </div>
            </ng-template>
          </ng-container>
          <span>
            <ng-template #guestView>
              <a
                href="/login"
                class="login-nav-link"
                *ngIf="displaySetting.pageTitlePrefix !== 'ShamalGroup-B2B'"
                >Login</a
              >
              <a
                (click)="onLogin()"
                [ngClass]="
                  appContext.siteName == 'ShamalGroup'
                    ? 'login-nav-link'
                    : 'login'
                "
                *ngIf="appContext.context?.authMechanism == 'auth0'"
                >Log In</a
              >
            </ng-template>
          </span>
        </li>
      </ul>
    </div>

<!-- class below was - back-button-container -->
    <div *ngIf="appContext.siteName !== 'ShamalGroup'" class="">
      <button
        class="navbar-toggler"
        type="button"
        (click)="isMobileToggle = !isMobileToggle"
        aria-label="Toggle navigation"
      >
        <mat-icon class="shamal-nav-menu">menu</mat-icon>
      </button>
    </div>
    <div [ngClass]="{'d-flex flex-row justify-content-center  align-items-center gap-2 sharecare-logo-center': appContext.siteName == 'Sharecare', 'logo-center': appContext.siteName !== 'Sharecare'}">
      <a
        class="navbar-brand"
        [href]="appContext.context.defaultRedirectionUrl ?? ''"
        [target]="appContext.siteName === 'Gocaribbea' ? '_blank' : '_self'"
      >
        <img
          src="{{ displaySetting?.header?.logo }} "
          alt="Logo Image"
          [ngClass]="{
            'sg-logowidth': appContext?.siteName == 'ShamalGroup',
            'bmg-logowidth':
              appContext?.siteName == 'BookMyGetaway' ||
              appContext?.siteName == 'BookMyGataway',
            'joylife-logowidth': appContext?.siteName == 'Joy' ? true : appContext?.siteName == 'DemoPortal',
            'goCarebbia-logowidth': appContext?.siteName == 'Gocaribbea',
            'secret-scapades-logowidth':
              appContext?.siteName == 'SecretEscapades',
            'oojo-logo-width': appContext?.siteName == 'Oojo',
            'logowidth-medium':
              appContext?.siteName == 'EroRentals' ||
              appContext?.siteName == 'HostMyTrips' ||
              appContext.siteName == 'OneStopParking',
            logowidth:
              appContext?.siteName !== 'ShamalGroup' &&
              appContext?.siteName !== 'Oojo' &&
              appContext?.siteName !== 'Joy' &&
              appContext?.siteName !== 'DemoPortal' &&
              appContext?.siteName !== 'Gocaribbea' &&
              appContext?.siteName !== 'EroRentals' &&
              appContext?.siteName !== 'BookMyGetaway' &&
              appContext?.siteName !== 'BookMyGataway' &&
              appContext?.siteName !== 'SecretEscapades'
          }"
        />

      </a>
      <span *ngIf="appContext?.siteName == 'Sharecare'" class="mt-4 p-1 d-none d-lg-block" >
        <p class="raleway-bold text-center fs-4 mt-1 text-black">Corporate Travel</p>
      </span>
    </div>

    <div
      class="contact"
      *ngIf="
        displaySetting?.header?.navText &&
        mobileView &&
        appContext.siteName !== 'ShamalGroup'
      "
    >
      <a
        [ngClass]="
          appContext.siteName == 'ReservationsExpert'
            ? 'resexpert-callus-btn'
            : ''
        "
        href="tel:{{ displaySetting?.header?.navText }}"
        ><mat-icon class="mat-icon">{{
          appContext.siteName == "ReservationsExpert" ? "phone" : "headset_mic"
        }}</mat-icon
        >{{ appContext.siteName == "ReservationsExpert" ? "Call Us" : "" }}</a
      >
      <!-- <a class="resexpert-callus-btn" href="tel:{{ displaySetting?.header?.navText }}"
      ><mat-icon class="mat-icon">phone</mat-icon> Call Us</a
    > -->
    </div>
     <div *ngIf="appContext.siteName == 'Sharecare' && mobileView">
        <div class="contact d-block d-lg-none mt-3" title=" 'Contact Support' "  >
          <a href="mailto:{{ displaySetting?.email }}"><mat-icon class="mat-icon w-10 h-10 "
              [ngStyle]="{'color' : 'var(--primary)'}">contact_support</mat-icon></a>
        </div>
      </div>
    <div *ngIf="mobileView && appContext.siteName == 'ShamalGroup'">
      <button
        class="navbar-toggler"
        type="button"
        (click)="isMobileToggle = !isMobileToggle"
        aria-label="Toggle navigation"
      >
        <mat-icon class="shamal-nav-menu">menu</mat-icon>
      </button>
    </div>

    <div
      [ngClass]="
        appContext.siteName == 'ReservationsExpert'
          ? 'collapse navbar-collapse justify-content-end'
          : 'collapse navbar-collapse justify-content-between'
      "
      [class.show]="isMobileToggle"
    >

      <div
        class="navMenu"
        [ngClass]="appContext.siteName == 'ShamalGroup' ? 'sg-flex' : ''"
        id="navbarResponsive "
        *ngIf="displaySetting?.header?.navLinks?.length > 0"
      >
        <ul
          class="navbar-nav menu-margin"
          [ngClass]="
            appContext.siteName == 'ShamalGroup' ? 'sg-menu-alignment' : 'mt-2'
          "
        >

          <li
            class="nav-item"
            *ngFor="let link of displaySetting?.header?.navLinks"
          >
            <a
              href="{{ link.href }}"
              [ngClass]="{
                'bmc-header-menu navanchor':
                  appContext?.siteName === 'Gocaribbea',
                'shamal-nav-link navanchor':
                  appContext?.siteName == 'ShamalGroup',
                'hmt-nav-link': appContext?.siteName == 'HostMyTrips',
                'nav-link': appContext?.siteName != 'HostMyTrips',
                'raleway-semibold sharecare-nav-link text-black': appContext?.siteName == 'Sharecare'
              }"
              [target]="
                this.appContext.siteName === 'ShamalGroup' &&
                link.text === 'Hotels'
                  ? ''
                  : '_blank'
              "
              ><span *ngIf="appContext?.siteName == 'HostMyTrips'"
                ><img class="link-icon" [src]="getImageUrl(link.text)" alt="" />
              </span>
              {{ link.text }}</a
            >
          </li>

        </ul>
      </div>

      <!-- code for desktop view -->

      <div
        class="nationality-main-div"
        *ngIf="
          (!mobileView && appContext.siteName == 'ShamalGroup') ||
          appContext.siteName != 'ShamalGroup'
        "
      >
        <div *ngIf="appContext.siteName == 'Gocaribbea'">
          <a (click)="openChat()" class="bmc-help">Help ?</a>
        </div>
        <ul class="navbar-nav roomdepo">
          <li
            class="nav-item"
            *ngIf="
              appContext.context?.authMechanism !== 'supabase' &&
              appContext.context?.authMechanism !== 'custom'
            "
          >
            <a
              href="mytrips"
              [ngClass]="{
                'joylife-fm-trip': appContext?.siteName == 'Joy' ? true : appContext?.siteName == 'DemoPortal',
                'nav-link': appContext?.siteName != 'Joy' ? (appContext?.siteName != 'DemoPortal') : false,
                'raleway-semibold sharecare-nav-link text-black ': appContext?.siteName == 'Sharecare'
              }"
              >{{
                appContext.siteName == "ReservationsExpert"
                  ? "My Reservation"
                  : "Find my trip"
              }}
            </a>
          </li>
          <div class="contact">
            <li
              *ngIf="
                displaySetting?.header?.navText &&
                !mobileView &&
                appContext.siteName !== 'ShamalGroup'
              "
            >
              <div>
                <mat-icon
                  class="mat-icon"
                  [ngStyle]="{
                    color:
                      appContext.siteName == 'OneStopParking' || appContext.siteName == 'Prestigate'
                        ? 'var(--primary)'
                        : '#000'
                  }"
                  >headset_mic</mat-icon
                >
                &nbsp;
                <a
                  href="tel:{{ displaySetting?.header?.navText }}"
                  [ngStyle]="{
                    color:
                      appContext.siteName == 'OneStopParking' || appContext.siteName == 'Prestigate'
                        ? 'var(--primary)'
                        : '#000'
                  }"
                  >{{ displaySetting?.header?.navText }}</a
                >
              </div>
            </li>

            <li
              class="nav-link"
              *ngIf="displaySetting?.header?.allowCurrencies.length > 1"
            >
              <p
                class="currency curncy"
                cdkOverlayOrigin
                #currencymenu="cdkOverlayOrigin"
                (click)="isCurrencyMenuOpen = !isCurrencyMenuOpen"
              >
                <span>{{ appService.userCurrency?.code }}</span>
                <i
                  style="padding-left: 0.5rem"
                  class="fa fa-caret-down"
                  aria-hidden="true"
                ></i>
          </p>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayHasBackdrop]="true"
                [cdkConnectedOverlayBackdropClass]="
                  'cdk-overlay-custom-backdrop'
                "
                [cdkConnectedOverlayOrigin]="currencymenu"
                [cdkConnectedOverlayOpen]="isCurrencyMenuOpen"
                (backdropClick)="isCurrencyMenuOpen = false"
              >
                <div class="menu-item">
                  <ul>
                    <li
                      *ngFor="
                        let item of displaySetting?.header?.allowCurrencies
                      "
                    >
                      <a (click)="onChangeCurrency(item)">{{ item }}</a>
                    </li>
                  </ul>
                </div>
              </ng-template>
            </li>
          </div>

          <li class="authList">
            <ng-container
              *ngIf="
                (userDetails != null &&
                  appContext?.siteName !== 'Gocaribbea' &&
                   appContext?.siteName !== 'SecretEscapades' &&
                     appContext?.siteName !== 'BookMyGetaway' &&
              appContext?.siteName !== 'BookMyGataway'&&
                    appContext?.siteName !== 'EroRentals' &&
                     appContext?.siteName !== 'HotelUsso' &&
                  displaySetting.pageTitlePrefix !== 'ShamalGroup-B2B' &&
                  this.appContext.siteName === 'ShamalGroup' &&
                  appContext.context?.authMechanism == 'auth0') ||
                  (auth.isLoggedIn &&
                  appContext?.siteName !== 'BookMyGetaway' &&
              appContext?.siteName !== 'BookMyGataway'&&
                    appContext?.siteName !== 'Gocaribbea' &&
                     appContext?.siteName !== 'SecretEscapades' &&
                      appContext?.siteName !== 'EroRentals' &&
                        appContext?.siteName !== 'HotelUsso' &&
                    displaySetting.pageTitlePrefix !== 'ShamalGroup' &&
                    this.appContext.siteName === 'ShamalGroup') ||
                  (auth.isLoggedIn &&
                  appContext?.siteName !== 'BookMyGetaway' &&
              appContext?.siteName !== 'BookMyGataway'&&
                    appContext?.siteName !== 'Gocaribbea' &&
                     appContext?.siteName !== 'EroRentals' &&
                       appContext?.siteName !== 'HotelUsso' &&
                     appContext?.siteName !== 'SecretEscapades' &&
                     appContext?.siteName !== 'alldotgay' &&
                    this.appContext.siteName !== 'ShamalGroup');
                else guestView
              "
            >
              <a
                class="user-name-view"
                cdkOverlayOrigin
                #usermenu="cdkOverlayOrigin"
                (click)="isUserMenuOpen = !isUserMenuOpen"
              >
                <i class="fa fa-user-circle user-icon" aria-hidden="true"></i>
                <span
                  *ngIf="displaySetting?.pageTitlePrefix !== 'ShamalGroup'"
                  [ngClass]="
                    appContext?.siteName == 'ShamalGroup'
                      ? 'sg-user-name'
                      : 'user-name'
                  "
                >
                  {{ auth?.UserInfo?.displayName }}
                </span>
              </a>

              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayHasBackdrop]="true"
                [cdkConnectedOverlayBackdropClass]="
                  'cdk-overlay-custom-backdrop'
                "
                [cdkConnectedOverlayOrigin]="usermenu"
                [cdkConnectedOverlayOpen]="isUserMenuOpen"
                (backdropClick)="isUserMenuOpen = false"
              >
                <div class="user-menu text-center">
                  <span *ngIf="appContext?.siteName === 'ShamalGroup'">
                    {{ userDetails?.email ?? "" }}
                  </span>
                  <a
                    [ngClass]="
                      appContext?.siteName == 'ShamalGroup' ? 'sg-logout' : ''
                    "
                    (click)="logout()"
                  >
                    <i class="fa fa-sign-out" aria-hidden="true"></i> Logout
                  </a>
                </div>
              </ng-template>
            </ng-container>

            <ng-template #guestView>
              <a
                (click)="onLogin()"
                [ngClass]="
                  appContext?.siteName == 'ShamalGroup'
                    ? 'login-nav-link'
                    : 'login'
                "
                *ngIf="appContext?.context?.authMechanism == 'auth0'"
              >
                Log In
              </a>

              <ng-container
                *ngIf="
                  appContext?.siteName === 'ShamalGroup' &&
                  !userDetails &&
                  appContext?.context?.authMechanism == 'supabase' &&
                  displaySetting?.pageTitlePrefix !== 'ShamalGroup-B2B'
                "
              >
                <a href="/login" class="login-nav-link">Login</a>
              </ng-container>
            </ng-template>
          </li>

          <li
            class="nav-item"
            style="list-style: none; letter-spacing: 2px"
            *ngIf="
              !userDetails &&
              appContext?.context?.authMechanism == 'supabase' &&
              appContext?.siteName !== 'ShamalGroup' &&
              appContext?.siteName !== 'alldotgay'
            "
          >
            <a (click)="openModal()" class="login-nav-link navanchor">Login</a>
          </li>

          <!-- Guest inline nav (alldotgay) — booking allowed without login,
               so guests still need access to My trips -->
          <ng-container
            *ngIf="!userDetails && appContext?.siteName === 'alldotgay'"
          >
            <li class="nav-item no-list-style letter-spacing alldotgay-guest-item">
              <a (click)="openModal()" class="login-nav-link navanchor alldotgay-guest-link">
                <i class="fa fa-sign-in icon-margin" aria-hidden="true"></i>
                Login
              </a>
            </li>
            <li class="nav-item no-list-style letter-spacing alldotgay-guest-item">
              <a href="/mytrips" class="login-nav-link navanchor alldotgay-guest-link">
                <i class="fa fa-suitcase icon-margin" aria-hidden="true"></i>
                My trips
              </a>
            </li>
          </ng-container>

          <li
            class="nav-item no-list-style letter-spacing"
            *ngIf="
              !userDetails &&
              appContext.context?.authMechanism == 'supabase' &&
              appContext?.siteName !== 'Gocaribbea' &&
              appContext?.siteName !== 'ShamalGroup' &&
              appContext?.siteName !== 'EroRentals' &&
              appContext?.siteName !== 'SecretEscapades' &&
              appContext?.siteName !== 'alldotgay'
            "
          >
            <a href="/login" class="login-nav-link navanchor">LOGIN</a>
          </li>

          <!-- Login for BookMyGetaway (no userDetails) -->
          <li
            class="nav-item no-list-style letter-spacing"
            *ngIf="
              !userDetails && this.appContext.context.authMechanism == 'custom'
            "
          >
            <a (click)="customSSOLogin()" class="nav-link navanchor">Login</a>
          </li>

          <!-- Logged-in user (BookMyGetaway) -->
          <ng-container
            *ngIf="
              userDetails && this.appContext.context.authMechanism == 'custom'
            "
          >
            <li class="nav-item no-list-style letter-spacing">
              <a
                [matMenuTriggerFor]="bookMyGetawayMenu"
                class="login-nav-link navanchor"
              >
                <i
                  class="fa fa-user-circle supa-user-icon"
                  aria-hidden="true"
                ></i>
                <i class="fa fa-caret-down caret-icon" aria-hidden="true"></i>
              </a>
            </li>

            <mat-menu #bookMyGetawayMenu="matMenu">
              <a
                mat-menu-item
                class="menu-link"
                href="/mytrips-details"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fa fa-suitcase icon-margin" aria-hidden="true"></i>
                My trips
              </a>
              <button mat-menu-item class="menu-link" (click)="customSSOLogout()">
                <i class="fa fa-sign-out icon-margin" aria-hidden="true"></i>
                Logout
              </button>
            </mat-menu>
          </ng-container>

          <!-- Logged-in user (Supabase) -->
          <ng-container
            *ngIf="
              userDetails && appContext?.context?.authMechanism === 'supabase'
            "
          >
            <li class="nav-item no-list-style letter-spacing">
              <a
                [matMenuTriggerFor]="supabaseMenu"
                class="login-nav-link navanchor"
              >
                <i
                  class="fa fa-user-circle supa-user-icon"
                  aria-hidden="true"
                ></i>
                <i class="fa fa-caret-down caret-icon" aria-hidden="true"></i>
              </a>
            </li>

            <mat-menu #supabaseMenu="matMenu">
              <a
                mat-menu-item
                class="menu-link"
                href="/mytrips-details"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fa fa-suitcase icon-margin" aria-hidden="true"></i>
                My trips
              </a>
              <button mat-menu-item class="menu-link" (click)="logoutSupabase()">
                <i class="fa fa-sign-out icon-margin" aria-hidden="true"></i>
                Logout
              </button>
            </mat-menu>
          </ng-container>
        </ul>
      </div>
      <div *ngIf="appContext.siteName == 'Sharecare' && !mobileView">
        <div class="contact d-none d-lg-block mt-4 " title="Contact Support" matTooltip="Contact Support" matTooltipPosition="below" matTooltipClass="sharecare-support-tooltip">
          <a href="mailto:{{ displaySetting?.email }}"><mat-icon class="mat-icon w-10 h-10 "
              [ngStyle]="{'color' : 'var(--primary)'}">contact_support</mat-icon></a>
        </div>
      </div>
    </div>
  </div>
</nav>
